/**
 *
 * Formats a Date object as a localized date string using Intl.DateTimeFormat.
 *
 * @param date - The Date object to format
 * @param locale - The BCP 47 language tag (e.g., 'en-US', 'de-DE', 'ja-JP'). Defaults to 'en-US'
 * @returns A localized date string (e.g., "03/01/2025" for en-US, "01.03.2025" for de-DE)
 *
 * @throws {RangeError} If the date is not a valid Date object
 */

export const formatLocalisedDate = (date: Date, locale: string = 'en-US'): string => {
  if (!(date instanceof Date) || isNaN(date.getTime())) {
    throw new RangeError('Invalid date provided to formatDate');
  }

  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
};
